// import { useEffect } from "react";
// import { useNavigate } from "react-router-dom";
// import { jwtDecode } from "jwt-decode";

// const GoogleAuthHandler = () => {
//   const navigate = useNavigate();

//   useEffect(() => {
//     const urlParams = new URLSearchParams(window.location.search);
//     const token = urlParams.get("token");
//     const refresh = urlParams.get("refresh");
//     const role = urlParams.get("role");
//     const profileVerified = urlParams.get("profile_verified");

//     if (token) {
//       try {
//         const decodedUser = jwtDecode(token);

//         localStorage.setItem("accessToken", token);
//         localStorage.setItem("refresh", refresh);
//         localStorage.setItem("role", role);
//         localStorage.setItem("user", JSON.stringify(decodedUser));

//         if (profileVerified === "true") {
//           navigate("/");
//         } else {
//           navigate("/UserSetUpProfile");
//         }

//         window.history.replaceState({}, document.title, "/");
//       } catch (error) {
//         console.error("Error decoding token:", error);
//         navigate("/login");
//       }
//     }
//   }, [navigate]);

//   return null;
// };

// export default GoogleAuthHandler;

import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { jwtDecode } from "jwt-decode";

const GoogleAuthHandler = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const token = urlParams.get("token");
    const role = urlParams.get("role");
    const profileVerified = urlParams.get("profile_verified");

    if (token) {
      try {
        const decodedUser = jwtDecode(token);

        if (profileVerified === "true") {
          localStorage.setItem("accessToken", token);
          localStorage.setItem("role", role);
          localStorage.setItem("user", JSON.stringify(decodedUser));

          window.location.href = "/";
        } else {
          navigate("/UserSetUpProfile", { state: { decodedUser } });
        }

        window.history.replaceState({}, document.title, "/");
      } catch (error) {
        console.error("Error decoding token:", error);
        navigate("/login");
      }
    }
  }, [navigate]);

  return null;
};

export default GoogleAuthHandler;
